import React, {useState, useEffect} from "react";
import Modal from "react-bootstrap/Modal";
import {Avatar, DatePicker} from "antd";
import ApiService from "../util/ApiService";
import Swal from "sweetalert2";
import "react-datepicker/dist/react-datepicker.css";
import locale from "antd/es/date-picker/locale/pt_BR";
import dayjs from "dayjs";
import {startOfMonth, endOfMonth, addMonths} from "date-fns";
import "./assets/css/ScalePosting.css";
import LoadingScreen from "../util/LoadingScreen";
import CustomPagination from "../util/CustomPagination";

const {RangePicker} = DatePicker;
import {AlertOutlined} from '@ant-design/icons';
import DutyDetailModal from "../dashboard/calender/dutyDetailModal";
import ScaleModal from "../dashboard/calender/scaleModal";
import ScaleModalInfo from "./scaleModalInfo";

const nextMonthStart = dayjs(startOfMonth(addMonths(new Date(), 1)));
const nextMonthEnd = dayjs(endOfMonth(addMonths(new Date(), 1)));

const ScalePostingModal = ({show, arraySelect, handleClose}) => {
    const [deletingId, setDeletingId] = useState(null);
    const [showScaleModal, setShowScaleModal] = useState(null);

    const [scaleConflictingId, setScaleConflictingId] = useState([]);
    const [modalVisibleDuty, setModalVisibleDuty] = useState(false);

    const [loadingGenerate, setLoadingGenerate] = useState(false);
    const [loadingDelete, setLoadingDelete] = useState(false);

    const [conflicts, setConflicts] = useState([]);
    const [scale, setScale] = useState([]);
    const [scaleData, setScaleData] = useState({
        dateRange: [nextMonthStart, nextMonthEnd],
        department_id: "",
        hospital_id: "",
        user_id: "",
    });

    const [localArray, setLocalArray] = useState([]);
    const [loading, setLoading] = useState(false);

    // Paginação
    const itemsPerPage = 5;
    const [currentPage, setCurrentPage] = useState(1);

    const totalItems = localArray.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    const paginatedItems = localArray.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    useEffect(() => {
        if (show) {
            const initialRange = [nextMonthStart, nextMonthEnd];
            setScaleData({
                dateRange: initialRange,
                user_id: "",
                hospital_id: "",
                department_id: "",
                date_start: initialRange[0].format("YYYY-MM-DD"),
                date_end: initialRange[1].format("YYYY-MM-DD"),
            });

            setLocalArray(arraySelect); // cópia local
            setCurrentPage(1);
        }
    }, [show, arraySelect]);


    const formatDateBR = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // mês começa do zero
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const save = async () => {
        setLoadingGenerate(true);
        const initialRange = [nextMonthStart, nextMonthEnd];
        const start = scaleData.date_start || initialRange[0].format("YYYY-MM-DD");
        const end = scaleData.date_end || initialRange[1].format("YYYY-MM-DD");

        const payload = {
            id: localArray.map(item => item.id),
            date_start: start,
            date_end: end,
        };

        try {
            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}scale/generate-scale`,
                payload,
                true
            );

            if (response.code === 200) {
                let infoHtml = response.message.map(item => {
                    return `<strong>Nome:</strong> ${item.name}<br/>
                      <strong>Vencimento:</strong> ${formatDateBR(item.due_date)}<br/>
                      <strong>OBS:</strong> ${item.scale}<br/><br/>`;
                }).join('');

                Swal.fire({
                    title: 'Plantões Lançados',
                    html: infoHtml,
                    icon: 'success',
                    confirmButtonText: 'Fechar'
                });
            }
        } catch (error) {

            if (error?.response?.status === 400 && error.response?.data?.data?.conflicts) {
                const conflictsData = error.response.data.data.conflicts;
                setConflicts(conflictsData);

                // Ordena o localArray para mostrar os conflitos primeiro
                const conflictIds = conflictsData.map(conflict => conflict.new_duty.scale_id);
                const sortedArray = [...localArray].sort((a, b) => {
                    const aHasConflict = conflictIds.includes(a.id);
                    const bHasConflict = conflictIds.includes(b.id);
                    return (aHasConflict === bHasConflict) ? 0 : aHasConflict ? -1 : 1;
                });
                setLocalArray(sortedArray);


                Swal.fire({
                    icon: 'warning',
                    title: 'Atenção!',
                    text: 'Existem conflitos nas escalas!',
                });
            } else {
                ApiService.handleApiError(error);
            }
        } finally {
            setLoadingGenerate(false);
        }
    };

    const handleDeleteItem = async (id) => {
        setDeletingId(id); // ativa loading no botão

        try {
            await new Promise(resolve => setTimeout(resolve, 500)); // simula tempo (remova em produção)

            if (localArray.length > 1) {
                const filtered = localArray.filter(item => item.id !== id);
                setLocalArray(filtered);

                if ((currentPage - 1) * itemsPerPage >= filtered.length && currentPage > 1) {
                    setCurrentPage(currentPage - 1);
                }
            } else {
                Swal.fire("Erro!", "Nenhuma escala selecionada!", "error").then(() => {
                    handleClose();
                });
            }
        } catch (err) {
            console.error("Erro ao excluir escala:", err);
        } finally {
            setDeletingId(null); // desativa loading
        }
    };


    const modalDutyConflicts = (conflitcs, scale) => {
        setScaleConflictingId(conflitcs.conflicting_duty.scale_id);
        setScale(scale);
        setShowScaleModal(true)
    }

    const handleModalDutyClose = (updatedScale) => {
        setShowScaleModal(false);

        if (updatedScale) {
            // Atualiza o item editado na listagem
            const updatedArray = localArray.map(item =>
                item.id === updatedScale.id ? { ...item, ...updatedScale } : item
            );

            // Remove o conflito da escala editada
            const updatedConflicts = conflicts.filter(conflict => conflict.new_duty.scale_id !== updatedScale.id);

            // Ordena novamente se ainda houver conflitos
            let finalArray = [...updatedArray];
            if (updatedConflicts.length > 0) {
                const conflictIds = updatedConflicts.map(conflict => conflict.new_duty.scale_id);
                finalArray.sort((a, b) => {
                    const aHasConflict = conflictIds.includes(a.id);
                    const bHasConflict = conflictIds.includes(b.id);
                    return (aHasConflict === bHasConflict) ? 0 : aHasConflict ? -1 : 1;
                });
            }

            // Atualiza o array local
            setLocalArray(finalArray);

            // Atualiza os conflitos
            setConflicts(updatedConflicts);

            // Ajusta a página se a edição afetar a ordenação
            const updatedIndex = finalArray.findIndex(item => item.id === updatedScale.id);
            const newPage = Math.floor(updatedIndex / itemsPerPage) + 1;

            if (newPage !== currentPage) {
                setCurrentPage(newPage);
            }
        }
    };

    const deleteConflicts = () => {
        // Verifica se existem conflitos no estado conflicts
        setLoadingDelete(true);
        try {


            if (conflicts?.length > 0) {
                const conflictIds = conflicts.map(conflict => conflict.new_duty.scale_id);

                const filtered = localArray.filter(item => !conflictIds.includes(item.id));

                setLocalArray(filtered);

                if (filtered.length === 0) {
                    Swal.fire("Erro!", "Todas escalas estão com conflito, portanto nenhuma escala selecionada!", "error").then(() => {
                        handleClose();
                    });
                    return;
                }
                // Atualiza corretamente a paginação:
                const newTotalItems = filtered.length;
                const newTotalPages = Math.ceil(newTotalItems / itemsPerPage);
                setCurrentPage(prev => (prev > newTotalPages ? newTotalPages : prev));

                Swal.fire("Sucesso!", "Todos os conflitos foram removidos!", "success");

                // Limpa os conflitos após remoção
                setConflicts([]);
            } else {
                Swal.fire("Aviso!", "Não há conflitos para excluir.", "info");
            }
        } catch (error) {
            // tratamento de erro
        } finally {
            setLoadingDelete(false);
        }
    };


    const getOrderMonthText = (orderMonth) => {
        switch (orderMonth) {
            case 0:
                return "Toda Semana";
            case 1:
                return "1ª Semana";
            case 2:
                return "2ª Semana";
            case 3:
                return "3ª Semana";
            case 4:
                return "4ª Semana";
            case 5:
                return "5ª Semana";
            default:
                return "Semana não especificada";
        }
    };

    const getWeekDayName = (dayIndex) => {
        const days = [
            "Domingo",
            "Segunda-feira",
            "Terça-feira",
            "Quarta-feira",
            "Quinta-feira",
            "Sexta-feira",
            "Sábado"
        ];
        return days[dayIndex] ?? "Dia inválido";
    };


    return (
        <>

            <Modal show={show} onHide={handleClose} centered size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Gerar Plantão</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* Filtro de Data */}
                    <div className="mb-3">
                        <label>Data</label>
                        <div className="form-control p-2">
                            <RangePicker
                                style={{border: "none", boxShadow: "none"}}
                                locale={locale}
                                format="DD/MM/YYYY"
                                value={scaleData.dateRange}
                                onChange={(dates) => {
                                    if (dates && dates.length === 2) {
                                        setScaleData(prev => ({
                                            ...prev,
                                            dateRange: dates,
                                            date_start: dates[0].format("YYYY-MM-DD"),
                                            date_end: dates[1].format("YYYY-MM-DD"),
                                        }));
                                    } else {
                                        setScaleData(prev => ({
                                            ...prev,
                                            dateRange: [],
                                            date_start: null,
                                            date_end: null,
                                        }));
                                    }
                                }}
                                getPopupContainer={(triggerNode) => document.body}
                                menuPortalTarget={document.body}
                                dropdownClassName="custom-range-picker-dropdown"
                                popupStyle={{
                                    zIndex: 999999,
                                    position: "absolute",
                                }}
                            />
                        </div>
                    </div>

                    {/* Lista compacta */}
                    <div className="table-responsive">
                        <table className="table table-bordered table-hover align-middle">
                            <thead className="table-light">
                            <tr>
                                <th>Profissional</th>
                                <th>Hospital</th>
                                <th>Ordem</th>
                                <th>Dia/Hora</th>
                                <th>Ações</th>
                            </tr>
                            </thead>
                            <tbody>
                            {paginatedItems.map((scale) => {
                                const conflictFound = conflicts.find(conflict => conflict.new_duty.scale_id === scale.id);


                                return (
                                    <tr
                                        key={scale.id}
                                        className={conflictFound ? "table-conflict" : ""}
                                    >
                                        <td>
                                            <Avatar
                                                src={scale?.user?.profile_image || process.env.REACT_APP_URL_STORAGE + 'src/perfil_icone.png'}
                                                size={24}
                                                className="me-2"
                                            />
                                            {scale.user.name}
                                            <br/>
                                            <small className="text-muted">
                                                {scale?.user?.ddd && scale?.user?.phone ? `(${scale.user.ddd}) - ${scale.user.phone}` : 'Telefone não informado'}
                                            </small>
                                        </td>
                                        <td>
                                            <strong>{scale.hospital?.name || "Não informado"}</strong><br/>
                                            <small className="text-muted">
                                                <i className="fa fa-map-marker-alt text-info me-1"></i>
                                                {scale.hospital?.city_name}, {scale.hospital?.uf}
                                            </small>
                                        </td>
                                        <td>
                                            <i className="fa fa-calendar-alt text-primary me-1"></i>
                                            {getOrderMonthText(scale.order_month)}
                                        </td>
                                        <td>
                                            <small className="text-muted">
                                                <i className="fa fa-calendar-day text-primary me-1"></i>
                                                {getWeekDayName(scale.duty_scale_day_wee_id)}<br/>
                                                <i className="fa fa-clock text-primary me-1"></i>
                                                {scale.time_begin?.slice(0, 5)} - {scale.time_end?.slice(0, 5)}<br/>
                                                <i className="fa fa-hourglass-half text-primary me-1"></i>
                                                {scale.total_hours?.slice(0, 5)} horas
                                            </small>
                                        </td>

                                        <td>

                                            {conflictFound && (
                                                <>
                                                    <button type="button" className="btn btn-sm btn-info mb-1 me-1 w-100"
                                                            onClick={() => modalDutyConflicts(conflictFound, scale)}>
                                                        <AlertOutlined style={{color: 'white', marginRight: '2px'}}
                                                                       title="Conflito nesta escala"/>  Conflito
                                                    </button><br/>
                                                </>
                                            )}
                                            <button
                                                title="Excluir da Seleção"
                                                type="button"
                                                className="btn btn-sm btn-danger w-100"
                                                onClick={() => handleDeleteItem(scale.id)}
                                                disabled={deletingId === scale.id}
                                            >
                                                {deletingId === scale.id ? (
                                                    <>
                                                        <span
                                                            className="spinner-border spinner-border-sm me-2"
                                                            role="status"
                                                            aria-hidden="true"
                                                        ></span>
                                                        Excluindo...
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="fa fa-trash me-1"></i>
                                                        Excluir
                                                    </>
                                                )}
                                            </button>

                                        </td>
                                    </tr>
                                );
                            })}
                            </tbody>

                        </table>
                    </div>

                    {/* Paginação com CustomPagination */}
                    <CustomPagination
                        pagination={{
                            current: currentPage,
                            total: totalItems,
                            perPage: itemsPerPage,
                            lastPage: totalPages
                        }}
                        onChange={(page) => setCurrentPage(page)}
                    />

                    <div className="modal-footer mt-3">
                        {conflicts.length > 0 && (
                            <button
                                type="button"
                                className="btn btn-danger mt-3"
                                onClick={() => deleteConflicts()}
                                disabled={loadingDelete || loadingGenerate}
                            >
                                {loadingDelete ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status"
                                              aria-hidden="true"></span>
                                        Excluindo...
                                    </>
                                ) : (
                                    <>
                                        <i className="fa fa-eraser me-1"></i> Excluir todos os Conflitos
                                    </>
                                )}
                            </button>
                        )}
                        <button type="button" className="btn btn-secondary mt-3" onClick={() => handleClose()}
                                disabled={loadingGenerate}>
                            <i className="fa fa-close"></i> Cancelar
                        </button>

                        <button
                            type="button"
                            className="btn btn-primary mt-3 me-2"
                            onClick={() => save()}
                            disabled={loadingGenerate}
                        >
                            {loadingGenerate ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status"
                                          aria-hidden="true"></span>
                                    Gerando...
                                </>
                            ) : (
                                <>
                                    <i className="fa fa-rocket me-2"></i> Gerar Plantão
                                </>
                            )}
                        </button>
                    </div>

                </Modal.Body>
            </Modal>

            <ScaleModalInfo
                id={scaleConflictingId}
                scaleOrigin={scale}
                show={showScaleModal}
                handleClose={handleModalDutyClose}
            />

        </>
    );
};

export default ScalePostingModal;
